import { tryParseJson } from "@poseidon/utils/obj";
import { collection, query } from "firebase/firestore";
import { db } from "@poseidon/firebase/firebase";
import { useEffect, useState } from "react";
import { useCollection } from "react-firebase-hooks/firestore";
import { default as config } from "@poseidon/utils/config";
import { getDate } from "@poseidon/firebase/timestamp";

export const useAmlChecks = (sailorId) => {
  const [amlChecks, setAmlChecks] = useState([]);
  const [value, loading, error] = useCollection(
    query(
      collection(
        db,
        config.SaltCollection.SailorRiskProfile,
        sailorId,
        config.SaltCollection.AmlCheck
      )
    )
  );
  useEffect(() => {
    if (value) {
      const docs = value.docs
        .map((snap) => {
          const data = snap.data();
          const error = tryParseJson(data.error) || data.error;
          const requestedAt = getDate(data.requestedAt);
          return { id: snap.id, ...data, error, requestedAt };
        })
        .sort((a, b) => (a.requestedAt < b.requestedAt ? 1 : -1));
      setAmlChecks(docs);
    }
  }, [value]);

  return { amlChecks, loading, error };
};
